import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_records_total_billed_by_date_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { date: string, ownerId?: number, projectId?: number, warehouseIds?: number[], materialIds?: number[] }): 
  Promise<{ result: { TotalAmount?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.date)) {
      $missingRequiredInParams.push('\'date\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      date: string, ownerId?: number, projectId?: number, warehouseIds?: number[], materialIds?: number[]    }) {
        if(isNil($inParams.date)) {
          return true; 
        }
      return false;
    }
}
